import React from 'react'
import Brandmark from '../general/Brandmark'
import PrimaryDesktop from './PrimaryDesktop'
import PrimaryMobile from './PrimaryMobile'

const Primary = () => {
    return (
        <>
            <Brandmark />
            <PrimaryDesktop />
            <PrimaryMobile />
        </>
    )
}

export default Primary
